module.exports = __webpack_public_path__ + "img/selected4-min.fb4131e5.png";